// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"f4f6d609","511":"770ceb7a","918":"542f9808","927":"4200c98e"}[chunkId] + ".js";
};